import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth-service';

export const permissionsGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // 1. Obtenemos el permiso requerido desde la ruta (ej: 'flota')
  const requiredPermission = route.data['permission'] as string;

  // Si la ruta no exige ningún permiso, pasa directo
  if (!requiredPermission) {
    return true;
  }

  // 2. Comprobamos si ya tenemos el usuario en el BehaviorSubject
  // Accedemos a través del truco de TypeScript para leer la propiedad privada 'userSubject'
  // o si lo prefieres, podrías añadir un getter público en tu AuthService: get currentUserValue() { return this.userSubject.value; }
  const currentUser = (authService as any).userSubject?.value;

  // Función interna para validar si el usuario cumple los requisitos
  const checkUserPermissions = (user: any): boolean => {
    return (
      user &&
      user.isActive &&
      user.preferences?.permisions?.includes(requiredPermission)
    );
  };

  // 3. Flujo de decisión reactivo
  if (currentUser) {
    // Caso A: El usuario ya está cargado en memoria
    if (checkUserPermissions(currentUser)) {
      return true;
    }
    router.navigate(['/unauthorized']);
    return false;
  } else {
    // Caso B: El usuario está vacío (ej: F5 / Recargar página).
    // Llamamos a fetchCurrentUser() para recuperarlo de la sesión/cookie de la API de forma transparente.
    return authService.fetchCurrentUser().pipe(
      map((userFetched) => {
        if (checkUserPermissions(userFetched)) {
          return true;
        }
        router.navigate(['/unauthorized']);
        return false;
      }),
      catchError(() => {
        router.navigate(['/login']);
        return of(false);
      })
    );
  }
};